@if (linkedTemplate.length>0) {
<div [ngClass]="{ 'mt-4': isFromLinkedTemplate }">
  <div *ngIf="!hideTitle" class="app__centered-item justify-between w-full">
    <p class="app__centered-item app__form--attribute--title !text-sm !text-[#1E1E20] font-semibold">
      {{ title }}
      <span class="text-[#25508E] font-bold ml-1"> ({{ linkedTemplate.length }}) </span>
    </p>
  </div>
  @for (template of linkedTemplate; track template; let i = $index) {
  <div
    class="mb-1.5 border-[#d3dce8] border-solid border rounded-lg"
    (click)="template?.writeAccess && (data.isUpdatedUi || isFromLinkedTemplate) ? viewModal(template, $event) : $event.stopPropagation()"
    [ngClass]="{ 'hover:cursor-pointer': template?.writeAccess && (data.isUpdatedUi || isFromLinkedTemplate) }"
  >
    <div
      class="flex justify-between h-16"
      [ngClass]="{
        'pl-[6px]': !isRemoveEditSaveSharing,
        'pl-4': isRemoveEditSaveSharing
      }"
    >
      <div class="app__centered-item">
        @if(!hideCheckbox){
        <mat-checkbox
          class="app__common--multiple--selection--checkbox"
          [(ngModel)]="selectionState['linked_template_' + i]"
          (change)="onLinkedTemplateSelectionChange(template, i, $event.checked)"
          (click)="$event.stopPropagation()"
        ></mat-checkbox>
        }
        @if(isFixedImage){
        <img style="margin-right: 12px; width: 48px" src="assets/images/discoveryVaultGroup/financial-list.svg" />
        }@else if(template?.key_path){
        <img class="back-avatar-grup rounded bg-[#f1f1f1] p-1" style="margin-right: 6px; width: 48px" [src]="template.key_path" />
        }@else{ @if(template.profile_image_url){ @if(data.isUpdatedUi || isFromLinkedTemplate){
        <img class="bg-[#f4f4f4] rounded p-1.5 h-10 mr-1.5" [src]="template?.profile_image_url" />
        }@else{
        <img class="w-[52px] h-[52px] rounded box-border mr-1.5" [src]="template.profile_image_url" />
        } }@else{
        <div class="w-[52px] h-[52px] rounded box-border mr-1.5">
          <file-extension [largeIcon]="true" [IconName]="template?.file_name | getFileExtension" [isActive]="true"> </file-extension>
        </div>
        } }
        <span class="flex flex-col gap-[6px] pl-3 m-0">
          @if(template?.key_path){
          <span
            class="app__form--attribute--title text-[14px] leading-none"
            [matTooltip]="template?.display_file_name ? (template.display_file_name | fileNameWithoutExtension) : template.form_name"
          >
            {{ template?.display_file_name ? (template.display_file_name | fileNameWithoutExtension) : (template.form_name | truncateStrPipe : 22) }}
          </span>
          }@else{ @if(template.vault_form_type){
          <span
            class="app__form--attribute--title text-[14px] leading-none"
            [matTooltip]="template?.display_file_name ? (template.display_file_name | fileNameWithoutExtension) : template.form_name"
          >
            {{ template?.display_file_name ? (template.display_file_name | fileNameWithoutExtension) : (template.form_name | truncateStrPipe : 22) }}
          </span>
          <span class="app__form--attribute--title text-[12px] text-[#515765] font-medium leading-none">{{ template.vault_form_type }}</span>
          }@else if(template?.file_name){
          <span
            class="app__form--attribute--title text-[14px] leading-none"
            [matTooltip]="template?.display_file_name ? (template.display_file_name | fileNameWithoutExtension) : template.form_name"
          >
            {{ template?.display_file_name ? (template.display_file_name | fileNameWithoutExtension) : (template.form_name | truncateStrPipe : 22) }}
          </span>
          <span class="app__form--attribute--title text-[12px] text-[#515765] font-medium leading-none">{{ template?.file_name | getFileExtension }}</span>
          } @else if(template?.form_name){
          <span class="app__form--attribute--title text-[14px] leading-none" [matTooltip]="template?.type">
            {{ template?.form_name | truncateStrPipe : 22 }}
          </span>
          <span class="app__form--attribute--title text-[12px] text-[#515765] font-medium leading-none">{{ template?.type | truncateStrPipe : 22 }}</span>
          } }
        </span>
      </div>
      <div class="app__centered-item">
      @if(data.isCapitalCommitment){

      <div class="flex flex-col gap-2 min-w-fit items-end">
        <p class="text-[12px] m-0 font-semibold">
          Total Commitment Balance:
          {{ template?.totalCommitment ?? 0 | currency : 'USD' : 'symbol' : '1.2-2' }}
        </p>

        <div class="relative w-[200px] h-5 rounded border border-[#5475C0] overflow-hidden bg-white">
          <div class="bg-[#5475C0] h-full absolute top-0 left-0 z-0" [style.width.%]="getProgressPercentage(template)"></div>
          <div
            class="absolute top-0 left-0 w-full h-full flex items-center justify-center whitespace-nowrap text-xs text-white z-[2] text-ellipsis text-truncate font-semibold"
            style="z-index: 2"
          >
            Remaining:{{ template?.remainingBalance ?? 0 | currency : 'USD' : 'symbol' : '1.2-2' }}
          </div>
          <div
            class="absolute top-0 left-0 w-full h-full flex items-center justify-center whitespace-nowrap text-xs text-[#5475C0] z-[3] text-ellipsis text-truncate font-semibold"
            [ngStyle]="{ 'clip-path': 'inset(0 0 0 ' + getProgressPercentage(template) + '%)' }"
            style="z-index: 3"
          >
            Remaining: {{ template?.remainingBalance ?? 0 | currency : 'USD' : 'symbol' : '1.2-2' }}
          </div>
        </div>
      </div>
      }@else{
      <div class="flex gap-[10px]">
        @if (template.api_source && template.api_source.includes('Mx')){ @if (template.connection_status === 'CONNECTED') {
        <button class="bg-[#E2F9E4] h-8 w-28 text-[#59AB62] rounded"><img src="assets/images/account-link.svg" /> Connected</button>
        } @if (template.connection_status && template.connection_status !== 'CONNECTED') {
        <button class="bg-[#25508E] h-8 w-28 text-white rounded" (click)="$event.stopPropagation(); reconnect(template)">Reconnect</button>
        } @if( template.connection_status == null || template.connection_status == undefined){
        <button class="bg-[#25508E] h-8 w-28 text-white rounded" (click)="$event.stopPropagation(); editFeedData(template)">Connect</button>
        }} @else{ @if (template.connection_status === 'CONNECTED') {
        <button class="bg-[#E2F9E4] h-8 w-28 text-[#59AB62] rounded"><img src="assets/images/account-link.svg" /> Connected</button>
        } } @if(template?.writeAccess && (data.isUpdatedUi || isFromLinkedTemplate)){
        <button class="bg-transparent p-0" (click)="viewModal(template, $event)">
          <img src="assets/images/exsting-form-suggestion.svg" class="m-0 h-6" />
        </button>
        }@else{
          @if(!fromManageSecurity){     
            <button
              class="bg-transparent h-8 w-28 text-[#25508E] border-solid border border-[#25508E] rounded"
              (click)="viewModal(template, $event); $event.stopPropagation()"
            >
              View</button>
          }
        }
      </div>
      }
      <button
        class="more-vote-btn mt-[-6px]"
        mat-icon-button
        [matMenuTriggerFor]="!isRemoveEditSaveSharing ? menuItem : null"
        [disableRipple]="true"
        [disabled]="isRemoveEditSaveSharing"
        [ngClass]="{ 'p-0  w-fit flex items-center': data?.isCapitalCommitment, 'text-[#C1C2C5] hover:cursor-default': isRemoveEditSaveSharing }"
        (click)="$event.stopPropagation(); $event.stopImmediatePropagation()"
      >
        <span class="material-icons">more_vert</span>
      </button>
      <mat-menu
        #menuItem="matMenu"
        yPosition="below"
        xPosition="before"
        class="w-[120px]"
      >
        <button (click)="deleteForm(template)" mat-menu-item class="popup-menu-item remove-link">
          <span class="relative flex items-center text-[#ff0000]">
            <img src="/assets/images/roleplayers/minus-circled-remove-icon.svg" alt="remove" class="mr-2" /> 
            <span>Remove</span>
          </span>
        </button>
      </mat-menu>
    </div>
    </div>
  </div>
  }
</div>
} @if (linkedTemplate.length ==0) {
<div>
  <div
    class="border rounded-lg font-semibold mt-3 border-[#d3dce8] border-solid"
    style="padding: 14px 28px; text-align: center"
    [ngClass]="{ 'flex items-center justify-center gap-4': isFromLinkedTemplate }"
  >
    @if(data.isCapitalCommitment){
    <span class="app__form--attribute--title font-semibold text-[12px] ml-2">
      No <span class="font-bold text-[#25508E]"> Capital Commitment</span> to show
    </span>
    }@else{
    <img class="" [src]="data.icon_path" [ngClass]="{ 'w-6 h-6 mb-0 mt-0': isFromLinkedTemplate, 'mb-3 mt-1 h-8': !isFromLinkedTemplate }" />
    <p class="text-sm font-semibold text-center" [ngClass]="{ 'm-[6px]': !isFromLinkedTemplate, 'm-0': isFromLinkedTemplate }">
      No <span class="font-bold" style="color: #25508e"> {{ title }}</span> to show
    </p>
    }
  </div>
</div>
}
